import * as React from 'react';
import '../styles/TitleBar.css';

/**
 * TitleBar - Web version (simplified)
 *
 * In the web version, we don't need window controls (minimize, maximize, close)
 * This component is kept for layout consistency but returns null.
 * The browser's native title bar handles these functions.
 */
export const TitleBar: React.FC = () => {
  // In web app, we don't render a custom title bar
  // Browser handles this natively
  return null;
};
